// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2412V","name":"styles_name__FicGo","phone":"styles_phone__1pifr"};